import { FC } from 'react';

import { ScaleVisualization } from '~src/interfaces/scale.interface';
import CheckBox, { CheckBoxType } from '~src/shared/form/Checkbox';
import * as SC from './scaleBoxItem.sc';

interface Props {
  type: ScaleVisualization;
  label?: string;
  scaleLength?: number;
  colorNumber: number;
  withHover: boolean;
  selected: boolean;
  reversed?: boolean;
  scaleSelected?: boolean;
  animated?: boolean;
  isPreview?: boolean;
  vertical?: boolean;
  checkboxOptions?: { isSelected: boolean };
  showCheckboxOptions?: boolean;
}

const ScaleBoxItem: FC<Props> = (props) => {
  const {
    type = ScaleVisualization.Nps,
    label = '...',
    scaleLength = 2,
    colorNumber = 1,
    withHover = false,
    selected = false,
    reversed = false,
    scaleSelected = false,
    checkboxOptions,
    showCheckboxOptions = false,
  } = props;
  return (
    <SC.ColoredBox
      className={props.vertical ? 'vertical' : ''}
      $scaleSelected={scaleSelected && !props.isPreview}
      $type={type}
      $animated={props.animated}
      $scaleLength={type === ScaleVisualization.Nps ? 11 : scaleLength}
      $reversed={Boolean(reversed)}
      $colorNumber={colorNumber}
      $selected={selected}
      $withHover={withHover}
      $isMinChar40={label.length <= 40}
      $showCheckboxOptions={showCheckboxOptions}
    >
      {checkboxOptions ? (
        <CheckBox isChecked={checkboxOptions.isSelected} type={CheckBoxType.CheckBox} id={label} />
      ) : null}
      <span>{type === ScaleVisualization.Nps ? colorNumber : label || '...'}</span>
    </SC.ColoredBox>
  );
};

export default ScaleBoxItem;
